"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _DetailsTooltip = _interopRequireDefault(require("../../tooltips/DetailsTooltip"));

var _Translator = _interopRequireDefault(require("../../../util/i18n/Translator"));

var _KeyboardUtils = _interopRequireWildcard(require("../../../util/KeyboardUtils"));

var _DragDropRow = _interopRequireDefault(require("../DragDropRow"));

var _dragScroll = _interopRequireDefault(require("../../../util/dragScroll"));

var _InlineMessage = _interopRequireDefault(require("../../general/InlineMessage"));

var _Button = _interopRequireDefault(require("../../buttons/Button"));

var _StatusIndicator = _interopRequireDefault(require("../../general/StatusIndicator"));

var _StretchContent = _interopRequireDefault(require("../../layout/StretchContent"));

var _ButtonGroup = _interopRequireDefault(require("../../layout/ButtonGroup"));

var _StateContainer = require("../../utils/StateContainer");

var _DeprecationUtils = require("../../../util/DeprecationUtils");

var _FlagUtils = require("../../../util/FlagUtils");

var _PropUtils = require("../../../util/PropUtils");

var _StatusTypes;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

/**
* @enum {string}
* @alias ExpandableRow.Statuses
* @desc An enum of expandable row statuses.
*/
var Statuses = {
  /** good */
  GOOD: "good",

  /** warning */
  WARNING: "warning",

  /** error */
  ERROR: "error"
};
var StatusTypes = (_StatusTypes = {}, (0, _defineProperty2.default)(_StatusTypes, Statuses.GOOD, _StatusIndicator.default.Types.SUCCESS), (0, _defineProperty2.default)(_StatusTypes, Statuses.WARNING, _StatusIndicator.default.Types.WARNING), (0, _defineProperty2.default)(_StatusTypes, Statuses.ERROR, _StatusIndicator.default.Types.ERROR), _StatusTypes);
/**
 * @enum {string}
 * @alias ExpandableRow.RowMessageTypes
 */

var RowMessageTypes = {
  /** warning */
  WARNING: "warning"
};
/**
 * @enum {string}
 * @alias ExpandableRow.ConfirmDeletePositions
 */

var ConfirmDeletePositions = {
  /** top */
  TOP: "top",

  /** bottom */
  BOTTOM: "bottom"
};
/**
 * @callback ExpandableRow~eventCallback
 * @param {object} event - reactjs synthetic event object
 */

/**
 * @callback ExpandableRow~onToggle
 *
 * @param {boolean} expanded
 *     Current expanded/collapsed state.
 */

/**
* @callback ExpandableRow~onEditButtonClick
*
* @param {object} e
*    The ReactJS synthetic event object.
*/

/**
* @callback ExpandableRow~onDelete
*/

/**
* @callback ExpandableRow~onDeleteCancelClick
*
* @param {object} e
*    The ReactJS synthetic event object.
*/

/**
* @callback ExpandableRow~onDeleteConfirmClick
*
* @param {object} e
*    The ReactJS synthetic event object.
*/

/**
 * @class ExpandableRow
 * @desc Basic expandable row component.
 *
 * @param {string} [data-id="expandable-row"]
 *     To define the base "data-id" value for the top-level HTML container.
 * @param {string|number} [id]
 *     Row id, which may be used as a numeric counter rather. Can compliment data-id.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {boolean} [stateless]
 *     To enable the component to be externally managed. True will relinquish control to the component's owner.
 *     False or not specified will cause the component to manage state internally.
 *     The "onToggle" callback will still be executed in case the owner is interested.
 *
 * @param {boolean} [expanded=false]
 *     Whether the row is expanded or collapsed.
 *     When not provided, the component will manage this value.
 * @param {array} [flags]
 *     Set the flag for "expandable-row-ordering" to use the updated CSS className
 * @param {ExpandableRow~onToggle} [onToggle]
 *     Callback to be triggered when the expand/collapse button is clicked.
 *
 * @param {string|object} [title]
 *     A string or JSX object that serves as the title shown on the row.
 * @param {string} [titleClassName]
 *     CSS classes to set on the row title.
 *
 * @param {string|object} [subtitle]
 *     A string or JSX object that serves as the subtitle shown on the row right below the title.
 *
 * @param {string} [image]
 *     HTTP path to an image. When specified, the image displays to the left of the title and subtitle.
 * @param {string} [icon]
 *     HTTP path to an icon. When specified, the icon displays to the left of the title and subtitle.
 *
 * @param {object} [content]
 *     A JSX object that represents the content to be shown when expanding the row.
 *
 * @param {string} [editViewRoute=""]
 *     Route to the 'edit mode' view.
 * @param {boolean} [isEditEnabled=true]
 *     Whether or not the 'edit' button is enabled.
 * @param {boolean} [showEdit=true]
 *     Whether or not the 'edit' button will be shown at all.
 * @param {object}  [editButton]
 *     If defined, will replace the default edit button implementation.
 *     For example, a ModalButton can be passed as shown here:
 *         <...editButton={
 *             <ModalButton
 *                 linkContent={editModalButton}
 *                 data-id="edit-btn"
 *                 inline={true}
 *                 modalTitle={this.props.editModalTitle}
 *                 maximize={true}
 *                 modalBody={this.props.editModalBody}>
 *             </ModalButton>}>
 *         />
 * @param {ExpandableRow~onEditButtonClick} [onEditButtonClick]
 *     Callback to be triggered when the 'edit' button is clicked (if present).
 *
 * @param {boolean} [showDelete=true]
 *     Whether or not the 'delete' button will be shown at all.
 * @param {object} [deleteButton]
 *     If defined, will replace the default delete button implementation.
 *     For example, a ModalButton can be passed as shown here:
 *         <...deleteButton={
 *             <ModalButton
 *                 linkContent={deleteModalButton}
 *                 data-id="delete-btn"
 *                 inline={true}
 *                 modalTitle={this.props.deleteModalTitle}
 *                 maximize={true}
 *                 modalBody={this.props.deleteModalBody}>
 *             </ModalButton>}>
 *         />
 * @param {ExpandableRow~onDelete} [onDelete]
 *     Callback to be triggered when the 'delete' button is clicked (if present).
 * @param {string} [labelDeleteConfirm]
 *     The message to display within the delete confirm dialog when asking for confirmation to delete a row.
 * @param {boolean} [confirmDelete=false]
 *     Whether or not a 'delete' action should show a confirmation dialog.
 * @param {ExpandableRow.ConfirmDeletePositions} [confirmDeletePosition=BOTTOM]
 *     Used to determine whether the confirm delete dialog will appear above or below the delete button.
 * @param {string} [confirmDeleteTitle]
 *     Title to set for Confirm Delete dialog tooltip
 * @param {object|function} [confirmDeleteContent]
 *     Optional custom content to replace the default delete confirmation tooltip content
 *     Can be a function that takes object(with only member so far {onCancel} )
 *     and returns custom Confirm Delete tooltip's content
 * @param {boolean} [showDeleteConfirm=false]
 *     Whether or not the confirm delete dialog is visible.
 *     When not provided, the component will manage this value.
 * @param {ExpandableRow~onDeleteCancelClick} [onDeleteCancelClick]
 *     Callback to be triggered when the 'cancel' button in a delete confirm dialog is clicked.
 * @param {ExpandableRow~onDeleteConfirmClick} [onDeleteConfirmClick]
 *     Callback to be triggered when the 'confirm' button in a delete confirm dialog is clicked.
 *
 * @param {ExpandableRow.Statuses} [status]
 *     The ExpandableRow.Statuses status to show on the right hand side of the row.
 * @param {ExpandableRow.RowMessageTypes} [rowMessage]
 *     Displays a message along the top of the expanded row above all row content including the title and row
  *    accessories.
 * @param {node} [rowAccessories]
 *     A right-aligned container where buttons, toggles, or anything else may be passed in to render on the right side
 *     of the row, just to the left of the expand button.
 *
 * @param {boolean} [waiting=false]
 *     If true, disables interaction with the row and reduces opacity of the layer.
 * @param {ExpandableRow~Ordering} [ordering]
 *     If exists, disables normal interaction with the row and adds ordering controls.
 *     Its properties are position, positionValue, total, onReorder, and onPositionValueChange.
 *
 * @example
 *         <h1>My Row Results</h1>
 *         <!-- note that all expanding rows must be in a div with the "result-set" css class or a wrapper component -->
 *         <ExpandableRow.SimpleWrapper>
 *             <ExpandableRow id="1" title={'row1'} subtitle={'row1 subtitle'} content={row1Content} />
 *             <ExpandableRow id="2" title={'row2'} subtitle={'row2 subtitle'} content={row2Content} />
 *             <ExpandableRow id="3" title={'row3'} subtitle={'row3 subtitle'} content={row3Content} />
 *         </ExpandableRow.SimpleWrapper>
 *
 *     You can also pass the content as a children of the component. This will overwrite any content passed in as a prop
 *
 *         <ExpandableRow title={titleJsx} subtitle={subtitleJsx}>
 *             {contentChildrenJsx}
 *         </ExpandableRow>
 */

/**
 * @typedef {object} ExpandableRow~Ordering
 * @property {number} position
 *  The current position of the row
 * @property {number} total
 *  Number of items in whole ordered list
 * @property {ExpandableRow~onReorder} onReorder
 *  Handler for changing the order
 * @property {function} onPositionValueChange
 *  Handler for editing the input field
 * @property {number} positionValue
 *  When provided, the value of the input field. When not provided, it's managed in-component
 */

/**
 * @typedef {function} ExpandableRow~onReorder
 * @param {number} from
 *  The current index of the item to be moved
 * @param {number} to
 *  The current index of the item that should be right after the moving item in the new order
 *  (If item 2 is moved to index 7, it will end up at index 6 because the list shifts after it is removed)
 */

var OrderingInput = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(OrderingInput, _React$Component);

  var _super = _createSuper(OrderingInput);

  function OrderingInput() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, OrderingInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getValue", function () {
      if (_this.state.value !== undefined) {
        return _this.state.value;
      }

      var _this$props$positionV = _this.props.positionValue,
          positionValue = _this$props$positionV === void 0 ? _this.props.position : _this$props$positionV;
      return positionValue;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_positionInRange", function (number) {
      var total = _this.props.total;

      if (number < 0) {
        return 0;
      } else if (number > total) {
        return total;
      } else {
        return number;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_inputValueToPosition", function (value) {
      return value === "" ? "" : (0, _parseInt2.default)(value) - 1;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleChange", function (e) {
      var value = _this._inputValueToPosition(e.target.value.replace(/[^0-9]/, ""));

      if (_this.props.onPositionValueChange) {
        _this.props.onPositionValueChange(value, e);
      } else {
        _this.setState({
          value: value
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_stopEvent", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleKey", function (e) {
      // sometimes position is not the actual position but something to show in the field,
      // so it still makes sense to check the range
      var position = _this._positionInRange(_this.props.position);

      var positionValue = _this._getValue();

      if (e.keyCode === _KeyboardUtils.default.KeyCodes.ARROW_UP) {
        // this is +2 rather than +1 because it's the index we're inserting this record before
        _this._handleReorder(position, _this._positionInRange(positionValue + 2));
      } else if (e.keyCode === _KeyboardUtils.default.KeyCodes.ARROW_DOWN) {
        _this._handleReorder(position, _this._positionInRange(positionValue - 1));
      } else if (e.keyCode === _KeyboardUtils.default.KeyCodes.ENTER) {
        _this._handleReorder(position, _this._positionInRange(positionValue));
      } else {
        return;
      }

      _this._stopEvent(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleDrag", _this._stopEvent);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleBlur", function () {
      return _this._handleReorder(_this._positionInRange(_this.props.position), // just making sure it's in range in case we're not being passed the actual position
      _this._positionInRange(_this._getValue()));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (e) {
      return e.target.select();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleReorder", function (from, to) {
      if (to !== "") {
        _this.props.onReorder(from !== "" ? from : undefined, to);
      }

      _this.setState({
        value: undefined
      });
    });
    return _this;
  }

  (0, _createClass2.default)(OrderingInput, [{
    key: "render",
    value: function render() {
      var value = this._getValue();

      return /*#__PURE__*/_react.default.createElement("input", {
        className: "ordering-controls__input",
        "data-id": this.props["data-id"],
        draggable: true // has to be draggable to override dragging
        ,
        onBlur: this._handleBlur,
        onChange: this._handleChange,
        onClick: this._handleClick,
        onDragStart: this._handleDrag,
        onKeyDown: this._handleKey,
        type: "text",
        value: value === "" ? value : value + 1
      });
    }
  }]);
  return OrderingInput;
}(_react.default.Component);

var StatelessExpandableRow = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(StatelessExpandableRow, _React$Component2);

  var _super2 = _createSuper(StatelessExpandableRow);

  function StatelessExpandableRow() {
    var _context2;

    var _this2;

    (0, _classCallCheck2.default)(this, StatelessExpandableRow);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, (0, _concat.default)(_context2 = [this]).call(_context2, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleExpandButtonClick", function () {
      if (_this2.props.onToggle) {
        _this2.props.onToggle(_this2.props.expanded);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleDrop", function (targetId, beingDraggedId) {
      if (targetId === beingDraggedId) {
        return;
      }

      if (_this2.props.ordering && _this2.props.ordering.onReorder) {
        _this2.props.ordering.onReorder(beingDraggedId, targetId);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_useNewClassName", function () {
      return (0, _FlagUtils.hasFlag)((0, _assertThisInitialized2.default)(_this2), "expandable-row-ordering");
    });
    return _this2;
  }

  (0, _createClass2.default)(StatelessExpandableRow, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.expanded && !prevProps.expanded) {
        (0, _setTimeout2.default)(function () {
          if (_this3.expandableRow) {
            _this3.expandableRow.scrollIntoView({
              behavior: "smooth",
              block: "nearest"
            });
          }
        }, 50);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this4 = this;

      var icon = this.props.icon;
      var baseClassName = "expandable-row";
      var showEditIcon = this.props.showEdit && this.props.isEditEnabled,
          showViewIcon = this.props.showEdit && !this.props.isEditEnabled,
          containerClassname = (0, _classnames2.default)(baseClassName, this.props.className, (_classnames = {
        expanded: this.props.expanded,
        waiting: this.props.waiting
      }, (0, _defineProperty2.default)(_classnames, "".concat(baseClassName, "--ordering-old-style"), this.props.ordering && !this._useNewClassName()), (0, _defineProperty2.default)(_classnames, "".concat(baseClassName, "--ordering"), this.props.ordering && this._useNewClassName()), (0, _defineProperty2.default)(_classnames, "has-image", !!this.props.image), (0, _defineProperty2.default)(_classnames, "has-icon", icon), (0, _defineProperty2.default)(_classnames, "no-delete", !this.props.showDelete), (0, _defineProperty2.default)(_classnames, "has-subtitle", this.props.subtitle), (0, _defineProperty2.default)(_classnames, "no-edit", !showEditIcon), _classnames)),
          deleteButton,
          editButton;

      if (this.props.showEdit) {
        editButton = this.props.editButton || /*#__PURE__*/_react.default.createElement(EditButton, {
          editViewRoute: this.props.editViewRoute,
          onClick: this.props.onEditButtonClick,
          showViewIcon: showViewIcon
        });
      }

      if (this.props.showDelete) {
        deleteButton = this.props.deleteButton || /*#__PURE__*/_react.default.createElement(_Button.default, {
          "data-id": this.props.confirmDelete ? "delete-btn-confirm" : "delete-btn",
          className: "delete-btn",
          onClick: this.props.onDelete
        });
      }

      var titleClassName = (0, _classnames2.default)("item-title", this.props.titleClassName);

      if (this.props.showDelete) {
        var deleteObject = this.props.deleteButton || /*#__PURE__*/_react.default.createElement(_Button.default, {
          "data-id": this.props.confirmDelete ? "delete-btn-confirm" : "delete-btn",
          className: "delete-btn",
          onClick: this.props.onDelete
        }); //details tooltip should be delete button


        if (this.props.confirmDelete || this.props.confirmDeleteContent) {
          deleteButton = /*#__PURE__*/_react.default.createElement(ConfirmDeleteDialog, {
            "data-id": "".concat(this.props["data-id"], "-confirm-delete-dialog"),
            trigger: deleteObject,
            label: this.props.labelDeleteConfirm,
            open: this.props.expanded && this.props.showDeleteConfirm,
            onCancel: this.props.onDeleteCancelClick,
            confirmDeleteTitle: this.props.confirmDeleteTitle,
            onDeleteConfirm: this.props.onDeleteConfirmClick,
            confirmDeletePosition: this.props.confirmDeletePosition
          }, this.props.confirmDeleteContent);
        } else {
          deleteButton = deleteObject;
        }
      }

      var rendered = /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(row) {
          return _this4.expandableRow = row;
        },
        "data-id": this.props["data-id"],
        className: containerClassname
      }, (this.props.rowAccessories || this.props.status) && /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "row-accessories",
        className: "row-accessories"
      }, this.props.rowAccessories, this.props.status && /*#__PURE__*/_react.default.createElement(_StatusIndicator.default, {
        "data-id": "status",
        type: StatusTypes[this.props.status],
        inline: true
      })), this.props.ordering && /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "ordering-controls",
        className: "ordering-controls"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-grip ordering-controls__grip"
      }), /*#__PURE__*/_react.default.createElement(OrderingInput, (0, _extends2.default)({
        "data-id": "ordering-input"
      }, this.props.ordering)), !this._useNewClassName() && this.props.ordering.total ? " / ".concat(this.props.ordering.total) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames2.default)("collapsed-content", icon && _underscore.default.isString(icon) ? "" : "collapsed-content--with-icon")
      }, this.props.image && /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.image,
        className: "item-image"
      }), icon && (_underscore.default.isString(icon) ? /*#__PURE__*/_react.default.createElement("span", {
        className: "item-icon " + icon
      }) : /*#__PURE__*/_react.default.createElement("span", {
        className: "collapsed-content__icon"
      }, icon)), /*#__PURE__*/_react.default.createElement("div", {
        className: titleClassName
      }, this.props.title), this.props.subtitle && /*#__PURE__*/_react.default.createElement("div", {
        className: "item-sub-title"
      }, this.props.subtitle)), this.props.expanded && /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "expanded-row",
        className: "expanded-content indent-content clearfix"
      }, this.props.rowMessage && /*#__PURE__*/_react.default.createElement(_InlineMessage.default, {
        "data-id": "item-message",
        className: "item-message",
        type: this.props.rowMessage.type,
        alternate: true
      }, this.props.rowMessage.text), /*#__PURE__*/_react.default.createElement("div", {
        className: "expanded-content-scroller"
      }, this.props.children || this.props.content)), /*#__PURE__*/_react.default.createElement("div", {
        className: "row-btns"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": "expand-btn",
        className: "expand-btn",
        onClick: this._handleExpandButtonClick
      }), !this.props.showEdit && /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-fill"
      }), editButton, deleteButton));

      if (this.props.ordering) {
        return /*#__PURE__*/_react.default.createElement(_DragDropRow.default, {
          className: "draggable-item",
          id: this.props.ordering.position,
          index: this.props.ordering.position,
          onDrop: this._handleDrop,
          onDragStart: _dragScroll.default.start,
          onDragEnd: _dragScroll.default.end
        }, rendered);
      } else {
        return rendered;
      }
    }
  }]);
  return StatelessExpandableRow;
}(_react.default.Component);

(0, _defineProperty2.default)(StatelessExpandableRow, "displayName", "StatelessExpandableRow");
(0, _defineProperty2.default)(StatelessExpandableRow, "contextTypes", {
  flags: _propTypes.default.arrayOf(_propTypes.default.string)
});
(0, _defineProperty2.default)(StatelessExpandableRow, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  expanded: _propTypes.default.bool,
  flags: _FlagUtils.flagsPropType,
  onToggle: _propTypes.default.func,
  title: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  titleClassName: _propTypes.default.string,
  subtitle: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  image: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  children: _propTypes.default.node,
  content: _propTypes.default.object,
  editViewRoute: _propTypes.default.string,
  isEditEnabled: _propTypes.default.bool,
  showEdit: _propTypes.default.bool,
  editButton: _propTypes.default.object,
  onEditButtonClick: _propTypes.default.func,
  showDelete: _propTypes.default.bool,
  deleteButton: _propTypes.default.object,
  onDelete: _propTypes.default.func,
  labelDeleteConfirm: _propTypes.default.string,
  confirmDelete: _propTypes.default.bool,
  confirmDeletePosition: _propTypes.default.string,
  confirmDeleteContent: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  showDeleteConfirm: _propTypes.default.bool,
  onDeleteCancelClick: _propTypes.default.func,
  onDeleteConfirmClick: _propTypes.default.func,
  status: _propTypes.default.oneOf([Statuses.GOOD, Statuses.ERROR, Statuses.WARNING]),
  rowAccessories: _propTypes.default.node,
  rowMessage: _propTypes.default.object,
  waiting: _propTypes.default.bool,
  ordering: _propTypes.default.shape({
    position: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf([""])]),
    total: _propTypes.default.number,
    onReorder: _propTypes.default.func,
    onPositionValueChange: _propTypes.default.func,
    positionValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf([""])])
  })
});
(0, _defineProperty2.default)(StatelessExpandableRow, "defaultProps", {
  "data-id": "expandable-row",
  expanded: false,
  editViewRoute: "",
  isEditEnabled: true,
  showEdit: true,
  onEditButtonClick: _underscore.default.noop,
  showDelete: true,
  onDelete: _underscore.default.noop,
  confirmDelete: false,
  showDeleteConfirm: false,
  confirmDeletePosition: ConfirmDeletePositions.BOTTOM,
  onDeleteCancelClick: _underscore.default.noop,
  onDeleteConfirmClick: _underscore.default.noop,
  waiting: false
});

var ConfirmDeleteDialog = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2.default)(ConfirmDeleteDialog, _React$Component3);

  var _super3 = _createSuper(ConfirmDeleteDialog);

  function ConfirmDeleteDialog() {
    var _context3;

    var _this5;

    (0, _classCallCheck2.default)(this, ConfirmDeleteDialog);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this5 = _super3.call.apply(_super3, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "_renderTooltipContent", function () {
      var cancelLabel = _Translator.default.translate("cancel");

      var confirmLabel = _Translator.default.translate("delete");

      if (!_this5.props.children) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, _this5.props.label), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
          cancelLabel: cancelLabel,
          onCancel: _this5.props.onCancel
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          "data-id": "confirm-delete",
          onClick: _this5.props.onDeleteConfirm
        }, confirmLabel)));
      }

      if (typeof _this5.props.children === "function") {
        return _this5.props.children({
          onCancel: _this5.props.onCancel,
          onConfirm: _this5.props.onDeleteConfirm,
          confirmLabel: confirmLabel,
          cancelLabel: cancelLabel
        });
      }

      return _this5.props.children;
    });
    return _this5;
  }

  (0, _createClass2.default)(ConfirmDeleteDialog, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_DetailsTooltip.default, {
        placement: "".concat(this.props.confirmDeletePosition, " left"),
        "data-id": this.props["data-id"],
        title: this.props.confirmDeleteTitle,
        label: this.props.trigger,
        open: this.props.open,
        onToggle: this.props.open ? this.props.onCancel : _underscore.default.noop
      }, this._renderTooltipContent());
    }
  }]);
  return ConfirmDeleteDialog;
}(_react.default.Component);

(0, _defineProperty2.default)(ConfirmDeleteDialog, "displayName", "ConfirmDeleteDialog");
(0, _defineProperty2.default)(ConfirmDeleteDialog, "propTypes", {
  "data-id": _propTypes.default.string,
  confirmDeletePosition: _propTypes.default.string,
  label: _propTypes.default.string,
  confirmDeleteTitle: _propTypes.default.string,
  onCancel: _propTypes.default.func,
  onDeleteConfirm: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
});
(0, _defineProperty2.default)(ConfirmDeleteDialog, "defaultProps", {
  "data-id": "delete-confirm-dialog",
  label: "",
  onCancel: _underscore.default.noop,
  onDeleteConfirm: _underscore.default.noop,
  confirmDeleteTitle: _Translator.default.translate("confirmdelete")
});

function EditButton(_ref) {
  var dataId = _ref["data-id"],
      editViewRoute = _ref.editViewRoute,
      onClick = _ref.onClick,
      showViewIcon = _ref.showViewIcon;

  /*
   * PingAccess guys need the ability to specify a non-hash route to edit rows.  In order to maintain
   * backwards compatibility, the component will only skip adding a hash to the edit url if the editViewRoute
   * starts with a '/'.
   */
  var _getEditViewRoute = function _getEditViewRoute(route) {
    if (!route) {
      return null;
    }

    if (route[0] === "/") {
      return route;
    }

    return "#/" + route;
  };

  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    "data-id": dataId,
    className: (0, _classnames2.default)({
      "edit-btn": !showViewIcon,
      "view-btn": showViewIcon
    }),
    href: _getEditViewRoute(editViewRoute)
  }, (0, _PropUtils.getClickableA11yProps)(onClick), {
    onClick: onClick
  }));
}

EditButton.propTypes = {
  "data-id": _propTypes.default.string,
  editViewRoute: _propTypes.default.string,
  onClick: _propTypes.default.func,
  showViewIcon: _propTypes.default.bool
};
EditButton.defaultProps = {
  "data-id": "edit-btn",
  onClick: _underscore.default.noop,
  showViewIcon: false
};
var ExpandableRow = (0, _StateContainer.inStateContainer)([{
  name: "expanded",
  initial: false,
  callbacks: [{
    name: "onToggle",
    transform: _StateContainer.toggleTransform
  }]
}, {
  name: "showDeleteConfirm",
  initial: false,
  callbacks: [{
    name: "onDelete",
    transform: function transform(e, showDeleteConfirm, _ref2) {
      var confirmDelete = _ref2.confirmDelete;
      return confirmDelete ? !showDeleteConfirm : false;
    }
  }, {
    name: "onDeleteConfirmClick",
    transform: function transform() {
      return false;
    }
  }, {
    name: "onDeleteCancelClick",
    transform: function transform() {
      return false;
    }
  }]
}])(StatelessExpandableRow);
ExpandableRow.displayName = "ExpandableRow";
ExpandableRow.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
/**
* @class ScrollingWrapper
* @memberof ExpandableRow
* @desc Wraps around a list of ExpandableRow components to display a scrolling list properly
*       You probably want to use it with an InfiniteScroll component
*
* @param {string} [data-id="scrolling-wrapper"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
* @param {node} [title]
*     Content to put in the title above the list
* @param {node} [heading]
*     Content to put above the list
*/
// list and wrapper components to make a list display correctly

var ScrollingWrapper = function ScrollingWrapper(_ref3) {
  var dataId = _ref3["data-id"],
      className = _ref3.className,
      title = _ref3.title,
      children = _ref3.children,
      heading = _ref3.heading,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["data-id", "className", "title", "children", "heading"]);
  return /*#__PURE__*/_react.default.createElement(_StretchContent.default, (0, _extends2.default)({
    "data-id": dataId,
    className: (0, _classnames2.default)("result-set", "result-set--stretched", className)
  }, props), title && /*#__PURE__*/_react.default.createElement("div", {
    className: "result-set__title"
  }, title), heading, /*#__PURE__*/_react.default.createElement(_StretchContent.default, {
    scrollable: true,
    className: "result-set__scroller"
  }, children));
};

ScrollingWrapper.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  title: _propTypes.default.node,
  heading: _propTypes.default.node
};
ScrollingWrapper.defaultProps = {
  "data-id": "scrolling-wrapper"
};
/**
* @class SimpleWrapper
* @memberof ExpandableRow
* @desc Wraps around a list of ExpandableRow components to display a scrolling list properly
*
* @param {string} [data-id="scrolling-wrapper"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
*/

var SimpleWrapper = function SimpleWrapper(_ref4) {
  var dataId = _ref4["data-id"],
      className = _ref4.className,
      children = _ref4.children,
      props = (0, _objectWithoutProperties2.default)(_ref4, ["data-id", "className", "children"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-id": dataId,
    className: (0, _classnames2.default)("result-set", className)
  }, props), children);
};

SimpleWrapper.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
SimpleWrapper.defaultProps = {
  "data-id": "simple-wrapper"
};
/**
* @class EditWrapper
* @memberof ExpandableRow
* @desc Wraps around a list of ExpandableRow components to display a scrolling list properly
*
* @param {string} [data-id="scrolling-wrapper"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
*/

var EditWrapper = function EditWrapper(_ref5) {
  var dataId = _ref5["data-id"],
      className = _ref5.className,
      children = _ref5.children,
      props = (0, _objectWithoutProperties2.default)(_ref5, ["data-id", "className", "children"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-id": dataId,
    className: (0, _classnames2.default)("expandable-row__edit-wrapper", className)
  }, props), children);
};

EditWrapper.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
EditWrapper.defaultProps = {
  "data-id": "edit-wrapper"
};
/**
* @class RowSection
* @memberof ExpandableRow
* @desc Creates a section of expandable rows
*
* @param {string} [data-id="scrolling-wrapper"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
*/

var RowSection = function RowSection(_ref6) {
  var dataId = _ref6["data-id"],
      className = _ref6.className,
      children = _ref6.children,
      title = _ref6.title,
      props = (0, _objectWithoutProperties2.default)(_ref6, ["data-id", "className", "children", "title"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-id": dataId,
    className: (0, _classnames2.default)("expandable-row-section", className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "expandable-row-section__title"
  }, title), children);
};

RowSection.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  title: _propTypes.default.node
};
RowSection.defaultProps = {
  "data-id": "row-section",
  title: ""
};
var FocusOutlineExpandableRow = (0, _KeyboardUtils.withFocusOutline)(ExpandableRow);
FocusOutlineExpandableRow.Statuses = Statuses;
FocusOutlineExpandableRow.RowMessageTypes = RowMessageTypes;
FocusOutlineExpandableRow.ConfirmDeletePositions = ConfirmDeletePositions;
FocusOutlineExpandableRow.ScrollingWrapper = ScrollingWrapper;
FocusOutlineExpandableRow.SimpleWrapper = SimpleWrapper;
FocusOutlineExpandableRow.RowSection = RowSection;
FocusOutlineExpandableRow.EditButton = EditButton;
FocusOutlineExpandableRow.EditWrapper = EditWrapper;
module.exports = FocusOutlineExpandableRow;